import { render, staticRenderFns } from "./mobile-multiselect-item-color.vue?vue&type=template&id=3a932f74&"
import script from "./mobile-multiselect-item-color.vue?vue&type=script&lang=js&"
export * from "./mobile-multiselect-item-color.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a932f74')) {
      api.createRecord('3a932f74', component.options)
    } else {
      api.reload('3a932f74', component.options)
    }
    module.hot.accept("./mobile-multiselect-item-color.vue?vue&type=template&id=3a932f74&", function () {
      api.rerender('3a932f74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/mobile-multiselect/mobile-multiselect-item-color.vue"
export default component.exports